import {
  CLEAR_CURRENT_USER,
  RECEIVE_PREFERENCES,
  REQUEST_PREFERENCES,
} from '../action_constants'

const defaultState = {
  preferences: [],
  genrePreferences: {
    hide_hiphop: false,
    hide_dance: false,
    hide_latin: false,
    hide_pop: false,
    hide_rnb: false,
    hide_african: false,
    hide_other: false,
  },
  isLoading: false,
}

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_PREFERENCES:
      return { ...state, isLoading: true }
    case RECEIVE_PREFERENCES:
      return {
        ...state,
        isLoading: false,
        preferences: action.preferences,
        genrePreferences: action.genrePreferences,
      }
    case CLEAR_CURRENT_USER:
      return defaultState
    default:
      return state
  }
}

export default preferences
